import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { FaEdit, FaTrash, FaFilePdf, FaExchangeAlt, FaEye } from "react-icons/fa";

const ActionDropdown = ({
    d,
    navigate,
    handleDeleteClick,
    openPdf,
    handleTransfert,
    isOpen,
    onToggle,
    onClose,
    role = "user", // ✅ par défaut user
}) => {
    const btnRef = useRef(null);
    const menuRef = useRef(null);

    // Fermer si on clique ailleurs
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !btnRef.current.contains(event.target)
            ) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, onClose]);

    const isComptable = role.toLowerCase().includes("comptable");

    const menu = (
        <div
            ref={menuRef}
            className="absolute bg-white border border-gray-200 rounded shadow-lg z-[9999] min-w-[160px]"
            style={{
                top: btnRef.current?.getBoundingClientRect().bottom + window.scrollY,
                left: btnRef.current?.getBoundingClientRect().right - 160 + window.scrollX
            }}
        >
            <button
                onClick={() => {
                    const path = isComptable
                        ? `/EspaceCompta/devis/consulter/${d.id}`
                        : `/EspaceClient/devis/consulter/${d.id}`;
                    navigate(path);
                    onClose();
                }}
                className="flex items-center w-full px-3 py-2 text-sm text-blue-600 hover:bg-blue-100"
            >
                <FaEye className="mr-2 text-blue-600" /> Consulter
            </button>

            {!isComptable && (
                <>
                    <button
                        onClick={() => { navigate(`/EspaceClient/devis/modifier/${d.id}`); onClose(); }}
                        className="flex items-center w-full px-3 py-2 text-sm text-gray-600 hover:bg-gray-100"
                    >
                        <FaEdit className="mr-2 text-gray-600" /> Modifier
                    </button>

                    <button
                        onClick={() => { handleDeleteClick(d); onClose(); }}
                        className="flex items-center w-full px-3 py-2 text-sm text-red-600 hover:bg-red-100"
                    >
                        <FaTrash className="mr-2 text-red-600" /> Supprimer
                    </button>

                    <button
                        onClick={() => { handleTransfert(d); onClose(); }}
                        className="flex items-center w-full px-3 py-2 text-sm text-purple-600 hover:bg-purple-100"
                    >
                        <FaExchangeAlt className="mr-2 text-purple-600" /> Transformer
                    </button>
                </>
            )}

            <button
                onClick={() => { openPdf(d.id); onClose(); }}
                className="flex items-center w-full px-3 py-2 text-sm text-green-600 hover:bg-green-100"
            >
                <FaFilePdf className="mr-2 text-green-600" /> PDF
            </button>
        </div>
    );

    return (
        <>
            <button
                ref={btnRef}
                onClick={onToggle}
                className="px-2 py-1 bg-gray-100 rounded hover:bg-gray-300 text-lg font-bold"
            >
                ⋮
            </button>
            {isOpen && ReactDOM.createPortal(menu, document.body)}
        </>
    );
};

export default ActionDropdown;
